<template>
    <div :ref="id" :id="id" :style="style"></div>
</template>

<script>
export default {
    data: () => ({
        map: null,
        markers: {},
        markers_google: {},
        fixed_markers: {},
        fixed_markers_google: {},
        directions: []
    }),
    props: {
        height: {
            type: Number,
            default: 800,
            required: false
        },
        id: {
            type: String,
            default: "map_internal",
            required: false
        },
        markersApi: {
            type: String,
            default: null,
            required: false
        },
        directionsApi: {
            type: String,
            default: null,
            required: false
        },
        fixedMarkersApi: {
            type: String,
            default: null,
            required: false
        },
        center: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        style: function() {
            return "height: " + this.height + "px; width: 100%";
        }
    },
    methods: {
        displayMarkers: function(fixed = false) {
            if (fixed) {
                var markers = this.fixed_markers;
                var markers_google = this.fixed_markers_google;
            } else {
                var markers = this.markers;
                var markers_google = this.markers_google;
            }
            if (!this.emptyObject(markers)) {
                for (const [key, value] of Object.entries(markers)) {
                    if (!markers_google[key]) {
                        this.addMarker(key, value, fixed);
                    }
                }
            }
        },
        addMarker: function(key, position = null, fixed = false) {
            if (fixed) {
                var markers = this.fixed_markers;
                var markers_google = this.fixed_markers_google;
            } else {
                var markers = this.markers;
                var markers_google = this.markers_google;
            }

            if (!markers[key]) markers[key] = position;
            else position = markers[key];

            var marker_data = {
                position: {
                    lat: parseFloat(position.lat),
                    lng: parseFloat(position.lng)
                },
                map: this.map,
                title: position.address
            };
            if (fixed)
                marker_data["icon"] = {
                    url: "/images/icons/parking.png",
                    scaledSize: new google.maps.Size(36, 36)
                };

            var marker = new google.maps.Marker(marker_data);

            var contentString =
                '<div id="content">' +
                '<div class="marker-info-title">' +
                "<span>" +
                position.address +
                "</span>" +
                "</div>" +
                '<div id="marker-info-body">' +
                "<span>" +
                (!!position.notes ? "<p>" + position.notes + "</p>" : "") +
                "</span>" +
                "</div>" +
                "</div>";

            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            marker.addListener("click", function() {
                infowindow.open(this.map, marker);
            });
            if (this.center) this.map.setCenter(marker.getPosition());
            markers_google[key] = marker;
        },
        removeMarker: function(key) {
            this.markers[key] = null;
            var marker_google = this.markers_google[key];
            if (!!marker_google) {
                marker_google.setMap(null);
                marker_google = null;
            }
            this.markers_google[key] = null;
        },
        clearMarkers: function() {
            this.markers = {};
            for (const [key, value] of Object.entries(this.markers_google)) {
                if (!!value) {
                    value.setMap(null);
                    value = null;
                    this.markers_google[key] = null;
                }
            }
        },
        moveToMarker: function(position) {
            this.map.setCenter(position);
        },
        addDirection: function(from, to, waypoints = []) {
            var direction = this.findDirection(from, to);
            if (!!direction) {
                if (!!direction.render) {
                    direction.render.setMap(this.map);
                    return;
                }
            }
            var directionsService = new google.maps.DirectionsService();
            var directionsRenderer = new google.maps.DirectionsRenderer();
            directionsRenderer.setMap(this.map);
            directionsRenderer.setOptions({
                preserveViewport: !!this.directionsApi,
                polylineOptions: {
                    strokeColor: this.randomColor()
                },
                markerOptions: {
                    visible: false
                }
            });
            var from_position = this.markers_google[from];
            var to_position = this.markers_google[to];
            if (!!from_position && !!to_position) {
                var request = {
                    origin: from_position.getPosition(),
                    destination: to_position.getPosition(),
                    travelMode: "DRIVING"
                };
                directionsService.route(request, function(response, status) {
                    if (status == "OK") {
                        directionsRenderer.setDirections(response);
                    }
                });
                if (!!direction) {
                    direction.render = directionsService;
                } else {
                    this.directions.push({
                        from: from,
                        to: to,
                        render: directionsRenderer
                    });
                }
            }
        },
        removeDirection: function(from, to) {
            try {
                var direction = this.findDirection(from, to);
                console.log("REMOVE DIRECTION " + direction);
                if (!!direction) {
                    direction.render.setMap(null);
                    direction.render = null;
                }
            } catch (ex) {
                console.log(ex);
            }
        },
        clearDirections: function() {
            this.directions.forEach(function(direction) {
                direction.render.setMap(null);
            });
        },
        setMarker: function(key, position, fixed = false) {
            if (fixed) {
                var markers = this.fixed_markers;
                var markers_google = this.fixed_markers_google;
            } else {
                var markers = this.markers;
                var markers_google = this.markers_google;
            }
            markers[key] = position;
            var marker_google = markers_google[key];
            if (!!marker_google) {
                marker_google.setMap(null);
                marker_google = null;
            }
            markers_google[key] = null;
        },
        assignMarkers: function(data, fixed = false) {
            if (!!data) {
                data.forEach(function(item, index) {
                    this.setMarker(index, item, fixed);
                }, this);
                this.displayMarkers(fixed);
            }
        },
        assignFixedMarkers: function(data) {
            return this.assignMarkers(data, true);
        },
        assignDirections: function(data) {
            if (!!data) {
                data.forEach(function({ id, from, to }) {
                    var from_id = id + "_" + from.id;
                    this.setMarker(from_id, from);
                    var to_id = id + "_" + to.id;
                    this.setMarker(to_id, to);
                    this.addMarker(from_id);
                    this.addMarker(to_id);
                    this.addDirection(from_id, to_id);
                }, this);
            }
        },
        findDirection: function(from, to) {
            return this.directions.find(
                item => item.from == from && item.to == to
            );
        },
        fetchMarkersParams: function() {
            return {};
        },
        fetchMarkers: function() {
            if (!!this.markersApi) {
                this.$root.request(
                    this,
                    this.markersApi,
                    "GET",
                    this.fetchMarkersParams(),
                    this.assignMarkers
                );
            }
        },
        refreshMarkers: function() {
            this.clearMarkers();
            this.fetchMarkers();
        },
        fetchDirectionsParams: function() {
            var filters = this.$root.pageFilters;
            var params = {};
            filters.forEach(item => {
                params[item.id] = item.value;
            });
            return params;
        },
        fetchDirections: function() {
            if (!!this.directionsApi) {
                this.$root.request(
                    this,
                    this.directionsApi,
                    "GET",
                    this.fetchDirectionsParams(),
                    this.assignDirections
                );
            }
        },
        refreshDirections: function() {
            this.clearMarkers();
            this.clearDirections();
            this.fetchDirections();
        },
        fetchFixedMarkers: function() {
            if (!!this.fixedMarkersApi) {
                this.$root.request(
                    this,
                    this.fixedMarkersApi,
                    "GET",
                    {},
                    this.assignFixedMarkers
                );
            }
        },
        submitSearch: function() {
            this.refreshDirections();
        }
    },
    created: function() {
        this.fetchMarkers();
        this.fetchDirections();
        this.fetchFixedMarkers();
    },
    mounted: function() {
        this.map = new google.maps.Map(this.$refs[this.id], {
            center: { lat: 43.818409, lng: 7.77842 },
            zoom: 15,
            fullscreenControl: false
        });
        this.$emit("map-ready");
    },
    watch: {
        // markers: {
        //     immediate: true,
        //     handler: function(val, oldVal) {
        //         this.map_markers.forEach(value => {
        //             value.setMap(null);
        //             value = null;
        //         });
        //         this.map_markers = [];
        //         this.markers.forEach(item => {
        //             this.placeMarker(item);
        //         });
        //     }
        // }
    }
};
</script>
